export default __webpack_public_path__ + "static/media/bike_image1.f9a139a7.jpg";